(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('CmsEditTopicController', CmsEditTopicController);

  /* ngInject */
  function CmsEditTopicController($stateParams, Flash, categoryService, cmsArticleService, cmsEventService, cmsHelpfulResourceService, cmsPolicyTemplateService, cmsQuickGuideService, cmsManualService, cmsTopicService, cmsWebinarService, sessionService) {
    const vm = this;

    vm.activate = activate;
    vm.articles = [];
    vm.categories = [];
    vm.events = [];
    vm.getHelpfulResources = getHelpfulResources;
    vm.getTopic = getTopic;
    vm.helpfulResources = [];
    vm.manuals = [];
    vm.policyTemplates = [];
    vm.quickGuides = [];
    vm.updateTopic = updateTopic;
    vm.topic = {};
    vm.topicForm = {};
    vm.webinars = [];

    vm.activate();

    function activate() {
      getArticles();
      getCategories();
      getEvents();
      getHelpfulResources();
      getManuals();
      getPolicyTemplates();
      getQuickGuides();
      getTopic();
      getWebinars();
    }

    function getArticles() {
      cmsArticleService(sessionService.getAuthToken()).query(response => { vm.articles = response; });
    }

    function getCategories() {
      categoryService(sessionService.getAuthToken()).query(response => { vm.categories = response; });
    }

    function getEvents() {
      cmsEventService(sessionService.getAuthToken()).query(response => { vm.events = response; });
    }

    function getHelpfulResources() {
      cmsHelpfulResourceService(sessionService.getAuthToken()).query(response => { vm.helpfulResources = response; });
    }

    function getManuals() {
      cmsManualService(sessionService.getAuthToken()).query(response => { vm.manuals = response; });
    }

    function getPolicyTemplates() {
      cmsPolicyTemplateService(sessionService.getAuthToken()).query(response => { vm.policyTemplates = response; });
    }

    function getQuickGuides() {
      cmsQuickGuideService(sessionService.getAuthToken()).query(response => vm.quickGuides = response);
    }

    function getTopic() {
      cmsTopicService(sessionService.getAuthToken()).get({id: $stateParams.id}, response => vm.topic = response);
    }

    function getWebinars() {
      cmsWebinarService(sessionService.getAuthToken()).query(response => { vm.webinars = response; });
    }

    function updateTopic() {
      cmsTopicService(sessionService.getAuthToken()).update({id: $stateParams.id}, vm.topic, _updateTopicSuccess, _updateTopicFailure);
    }

    function _updateTopicSuccess() {
      Flash.create('success', 'Topic was successfully updated.');
    }

    function _updateTopicFailure() {
      Flash.create('danger', 'An error occurred saving topic.');
    }
  }
})();
